const styles = {
  wrapper: {
    display: 'flex',
    alignItems: 'center',
    borderBottom: '1px solid #DFE2E5',
    padding: '0 14px',
  },
  formWrapper: {
    display: 'flex',
    alignItems: 'center',
    alignSelf: 'flex-start',
  },
  itemsBlock: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    height: '100%',
    paddingBottom: 10.5,
    minHeight: 50,
  },
  itemWrapper: {
    display: 'flex',
    alignItems: 'center',
    height: 28,
    backgroundColor: '#F2F2F2',
    padding: '0px 5px',
    marginLeft: 10.5,
    marginTop: 10.5,
  },
  title: {
    fontSize: 18,
  },
  icon: {
    display: 'flex',
    transition: 'transform .3s',
    marginLeft: 8,
    cursor: 'pointer',
    '&:hover': {
      transform: 'scale(1.2)',
    },
  },
}
export default styles



// WEBPACK FOOTER //
// ./src/Components/Chat/ChatParticipantsForm/styles.js